import { React, useState, useEffect, useCallback } from "react";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import { useDropzone } from "react-dropzone";
import { useNavigate } from "react-router-dom";
import { Button, Col, Modal, Row } from "react-bootstrap";
import { v4 as uuidv4 } from "uuid";
import { Tooltip } from "@mui/material";

import *  as assessmentAPi from "../../api/assessmentApi";
import * as commonApi from "../../api/commonApi";
import { AssessmentInfo } from "./AssessmentInfo";
import { Header, LoadingSpinner, errorMsg, success } from "../Shared";
import { Common, SessionStorageKeys, Marking, MarkingColors, MarkingLevels, AssessmentDisabledTexts, SUCCESS, ERROR, Url, MarkingOutcome, TafCount, YearString, NavigationBar } from "../../helper";
import { isEmptyArray, isEmptyObject, SessionStorage } from "../../util";
import { setAddNewAssessment, setLatestAssessment, setMark, setAssessmentInfo } from "../../store/assessmentSlice"
import { ActualOutcome } from "./OutcomeCalculator"
import { setSelect } from "../../store/stylesSlice";

import "../../assets/stlyes/Assessment/assessment.scss";
import "../../assets/stlyes/Assessment/ObjectiveBlock.scss"
import "../../assets/stlyes/Assessment/dropdown.scss"

import AddW from "../../assets/images/AddWhite.png";
import Chat from "../../assets/images/AssessmentChat.png";
import SaveBtn from "../../assets/images/Save.png"
import EditGrey from "../../assets/images/EditGrey.png"
import Remove from "../../assets/images/MinusRemove.png"
import WhitePriorMarking from "../../assets/images/WhitePriorMarking.png";
import ClassHomeUploadIcon from "../../assets/images/ClassHomeUploadIcon.svg"
import AttachFile from "../../assets/images/Attach_File_White_Icon.svg"
import AttachFileBlue from "../../assets/images/Attach_file_Blue_Icon.svg"
import RoundButtonCheked from "../../assets/images/Radio_button_checked.svg"
import RoundButtonRedColor from "../../assets/images/RoundButtonRedColor.svg"

const AssessmentMarking = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const assessmentData = useSelector((state) => state.assessmentData)
  const markingData = useSelector((state) => state.assessmentData.markings);
  const pupilId = useSelector((state) => state.assessmentData.assessmentInfo.pupilId);
  const year = useSelector((state) => state.assessmentData.currentYear);
  const classId = useSelector((state) => state.marking.classId);
  const isNavCollapsed = useSelector((state) => state.styleData.isNavCollapsed)
  const [submittedDisplay, setSubmittedDisplay] = useState(false);
  const [asstSaved, setAsstSaved] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isSubmited, setIsSubmitted] = useState();
  const [assmnt, setassmnt] = useState();
  const [evidence, setEvidence] = useState();
  const [openCommentModal, setOpenCommentModal] = useState(false);
  const [priorMarks, setPriorMarks] = useState();
  const [hidepriorMarks, sethidePriorMarks] = useState(false);
  const [overAllData, setOverAllData] = useState();
  const [twoDArray, setTwoDArray] = useState()
  const [assessmentId, setAssessmentId] = useState("")
  const [objectives, setObjectives] = useState();
  const [teacherOutcome, setTeacherOutcome] = useState();
  const [studentOutcome, setStudentOutcome] = useState("")
  const [isHovered, setIsHovered] = useState(false);
  const [openEvidenceModal, setOpenEvidenceModal] = useState(false);
  const [displayEvidence, setDisplayEvidence] = useState([]);
  const [allEvidence, setAllEvidence] = useState([]);
  const [selectEvidences, setSelectEvidences] = useState([]);
  const [files, setFiles] = useState([]);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [selectedEvidence, setSelectedEvidence] = useState();
  const [commentText, setCommentText] = useState();
  const [tempComment, setTempComment] = useState();
  const [isAllMarked, setIsAllMarked] = useState(true);
  const [onLoad, setOnLoad] = useState(true);
  const [teacherOutComeOptions, setTeacherOutcomeOptions] = useState("")
  const [teacherOutcomeFinal, setTeacherOutcomeFinal] = useState()
  const [mappixOutcomeFinal, setMappixOutcomeFinal] = useState()

  const onDrop = useCallback(acceptedFiles => {
    setFiles([...acceptedFiles]);
  }, [files]);

  const getTeacherOutcome = (e) => {
    setTeacherOutcome(e.value)
    setTeacherOutcomeFinal(e.value)
  }

  const openCommentBox = () => {
    setOpenCommentModal(true)
  }

  const handleClose = () => {
    setOpenCommentModal(false)
  }

  const togglePriorMarking = () => {
    sethidePriorMarks(!hidepriorMarks)
  }

  const setDatas = (value) => {
    value.markings.sort((a, b) => a.order - b.order);
    setOverAllData(value)
  }

  const getCards = async (value) => {
    setIsLoading(true)
    const _criteria = await assessmentAPi.fetchDescriptionCriteria({ year, "identifier": value.Items.markings[3].generalIdentifier });
    if (!isEmptyArray(_criteria.Items)) {
      setTwoDArray(new Array((_criteria.Items.length * 3) + 1).fill(0).map(() => new Array(value.Items.markings.length).fill(0)))
      setOverAllOutCome(value.Items.outcome)
      setCommentText(value.Items.comment)
      setIsLoading(false)
    }
  }

  const getAssessment = async (assessmentId) => {
    setIsLoading(true)
    const _assessment = await assessmentAPi.getAssessment({ id: assessmentId });
    if (!isEmptyObject(_assessment)) {
      if (_assessment.Items.isSubmited) {
        setSubmittedDisplay(true)
      } else if (!_assessment.Items.isSubmited) {
        setSubmittedDisplay(false)
      }
    }
    if (!isEmptyObject(_assessment)) {
      getCards(_assessment)
      setDatas(_assessment.Items);
      SessionStorage.setItem(SessionStorageKeys.Assessment, JSON.stringify(_assessment.Items))
      dispatch(setAssessmentInfo(_assessment.Items))
      setIsSubmitted(_assessment.Items.isSubmited);
      setassmnt(assessmentData.assessmentInfo);
      setObjectives(_assessment.Items.markings)
      setEvidence(_assessment.Items.evidences);
      setStudentOutcome(_assessment.Items.outcome)
      setTeacherOutcomeFinal(_assessment.Items.teacherOutcome)
      setMappixOutcomeFinal(_assessment.Items.mappixOutcome)
      setTeacherOutcome(_assessment.Items.teacherOutcome)
      setIsLoading(false)
    }
    else {
      setIsLoading(false)
    }

    const _previousMarkings = await assessmentAPi.getPriorMarkings({ pupilId, year });
    if (isEmptyArray(_previousMarkings.Items)) {
      setIsLoading(false)
    } else {
      const array = _previousMarkings.Items.filter((item) => item.order)
      setPriorMarks(array.sort((a, b) => a.order - b.order))
    }
  }

  const markingColour = (marking) => {
    let bg = AssessmentDisabledTexts.None;
    if (year === 6 || year === 2) {
      if (!marking) {
        bg = MarkingColors.Absent
      }
      else {
        let last = marking[1]
        bg = last === "B" ? "var(--below-colour)" : last === "W" ? "var(--emerging-colour)" : last === "E" ? "var(--expected-colour)" : "var(--greater-colour)"
      }
    } else {
      if (!marking) {
        bg = MarkingColors.Absent
      }
      else {
        switch (marking.slice(1)) {
        case MarkingOutcome.G_Secure: bg = MarkingColors.GreaterDepth
          break;
        case MarkingOutcome.G_GoodFit: bg = MarkingColors.GreaterDepth
          break;
        case MarkingOutcome.E_Secure: bg = MarkingColors.Expected
          break;
        case MarkingOutcome.E_GoodFit: bg = MarkingColors.Expected
          break;
        case MarkingOutcome.E_Just: bg = MarkingColors.Expected
          break;
        case MarkingOutcome.W_Secure: bg = MarkingColors.Emerging
          break;
        case MarkingOutcome.W_GoodFit: bg = MarkingColors.Emerging
          break;
        case MarkingOutcome.W_Just: bg = MarkingColors.Emerging
          break;
        case MarkingOutcome.Below: bg = MarkingColors.Below
          break;
        case "G": bg = MarkingColors.GreaterDepth
          break;
        case "E": bg = MarkingColors.Expected
          break;
        case "W": bg = MarkingColors.Emerging
          break;
        case "B": bg = MarkingColors.Below
          break;
        default: bg = MarkingColors.Absent
        }
      }
    }
    return bg
  }

  const handleCreateAssessment = async () => {
    setIsLoading(true)
    setTeacherOutcomeFinal("")
    const _assessment = await assessmentAPi.fetchAssessmentMarkingNamesByPupilId({ pupilId, year });

    if (!isEmptyObject(_assessment)) {
      getCards(_assessment)
      setDatas(_assessment.Items);
      setassmnt(_assessment.Items);
      setObjectives(_assessment.Items.markings)
      setEvidence(_assessment.Items.evidences);
    }
    else {
      setIsLoading(false)
    }
    let _previousMarkings = await assessmentAPi.getPriorMarkings({ pupilId, year });
    if (isEmptyArray(_previousMarkings ? _previousMarkings.Items : [])) {
      setIsLoading(false)
    } else {
      const array = _previousMarkings.Items.filter((item) => item.order)
      setPriorMarks(array.sort((a, b) => a.order - b.order))
    }
    setIsLoading(false)
    dispatch(setAddNewAssessment(false))
  }
  const handleAssessmentSave = async () => {
    let newAssesmentId = "";
    if (assessmentData.latestAssessment[0]?.assessmentId) {
      setAssessmentId(assessmentData.latestAssessment[0]?.assessmentId) //Setting assessment Id from draft
      let formData = {
        "id": assessmentId, // assessmentId,
        "comment": commentText,
        "outcome": teacherOutcome ? teacherOutcome : `${mappixOutcomeFinal}`,
        "year": overAllData?.year,
        "markings": overAllData?.markings,
        "teacherOutcome": teacherOutcome === undefined ? "" : teacherOutcome,
        "mappixOutcome": `${mappixOutcomeFinal}`
      }
      let updateMarkById = await assessmentAPi.updateMarkById(formData);
      if (updateMarkById?.Items) {
        success(SUCCESS.ASSESSMENT_SAVED)
        await assessmentAPi.addEvidenceToAssessment({ id: assessmentId && assessmentId, evidence })
        const _assessment = await assessmentAPi.getAssessment({ id: assessmentId && assessmentId });
        setEvidence(_assessment.Items.evidences);
        setAsstSaved(true)
      } else {
        errorMsg(ERROR.UPDATE)
      }
    } else {
      let newAssessment = await assessmentAPi.createNewAssessment({ pupilId })
      setAssessmentId(newAssessment && newAssessment?.Items?.id) //Setting assessment Id freshly when clicked on add button
      newAssesmentId = newAssessment?.Items?.id
      let latestAssessment = [{ assessmentId: newAssesmentId }]
      dispatch(setLatestAssessment(latestAssessment))
      let formData = {
        "id": newAssesmentId, // assessmentId,
        "comment": commentText,
        "outcome": teacherOutcome ? teacherOutcome : `${mappixOutcomeFinal}`,
        "year": overAllData?.year,
        "markings": overAllData?.markings,
        "teacherOutcome": teacherOutcome === undefined ? "" : teacherOutcome,
        "mappixOutcome": `${mappixOutcomeFinal}`
      }
      let updateMarkById = await assessmentAPi.updateMarkById(formData);
      if (updateMarkById?.Items) {
        success(SUCCESS.ASSESSMENT_SAVED)
        await assessmentAPi.addEvidenceToAssessment({ id: newAssesmentId && newAssesmentId, evidence })
        const _assessment = await assessmentAPi.getAssessment({ id: newAssesmentId && newAssesmentId });
        setEvidence(_assessment.Items.evidences);
        setAsstSaved(true)
      } else {
        errorMsg(ERROR.UPDATE)
      }
    }

  }

  const handleAssessmentDelete = async () => {
    let deleteAssessmentById = await assessmentAPi.deleteAssessmentById({ id: assessmentId });
    if (isEmptyObject(deleteAssessmentById)) {
      navigate(-1)
      success(SUCCESS.ASSESSMENT_DELETED_SUCCESSFULLY)
    } else {
      errorMsg(ERROR.UPDATE)
    }
  }

  const handleSubmit = async () => {
    setIsLoading(true);
    setSubmittedDisplay(true)
    let formData2 = {
      "pupilId": assessmentData.assessmentInfo.pupilId,
      assessmentId,
      "year": overAllData.year,
      "markings": overAllData.markings
    }
    let updateMarksByPupilId = await assessmentAPi.updateMarksByPupilId(formData2);
    if (updateMarksByPupilId.Items) {
      success(SUCCESS.ASSESSMENT_SUBMITTED)
      navigate(-1)
    } else {
      errorMsg(ERROR.UPDATE)
      setSubmittedDisplay(false)
    }
    setIsLoading(false);
  }

  const calculateOutcome = async () => {
    if (year === 2 || year === 6) {
      const { studentOutcome } = ActualOutcome(twoDArray, year)
      setStudentOutcome(studentOutcome)
      setMappixOutcomeFinal(studentOutcome)
    } else if (year === 1 || year === 3 || year === 4 || year === 5) {
      let blue = 0;
      let green = 0;
      let yellow = 0;
      let red = 0;
      let objectiveCount = 0;
      overAllData.markings.map((obj) => {
        if (obj.markings[0][1] !== undefined) {
          if (obj.markings[0] === `${year}B`) {
            red = red + 1;
          } else if (obj.markings[0] === `${year}G`) {
            blue = blue + 1;
          } else if (obj.markings[0] === `${year}E`) {
            green = green + 1;
          } else if (obj.markings[0] === `${year}W`) {
            yellow = yellow + 1;
          }
        }
        return "";
      })
      switch (year) {
      case YearString.Year1:
        objectiveCount = TafCount.Year1
        break;
      case YearString.Year2:
        objectiveCount = TafCount.Year2
        break;
      case YearString.Year3:
        objectiveCount = TafCount.Year3
        break;
      case YearString.Year4:
        objectiveCount = TafCount.Year4
        break;
      case YearString.Year5:
        objectiveCount = TafCount.Year5
        break;
      case YearString.Year6:
        objectiveCount = TafCount.Year6
        break;
      default:
        break;
      }
      const NewValue = await assessmentAPi.pupilOutcomeCalculation({ subtotalAmberBlueGreen: (blue + green + yellow), subtotalBlueGreen: (blue + green), subtotalBlue: blue, subtotalDescriptions: objectiveCount })
      switch (NewValue.Items) {
      case "G-S":
        setMappixOutcomeFinal(`${year}${MarkingOutcome.G_Secure}`)
        break;
      case "G-G":
        setMappixOutcomeFinal(`${year}${MarkingOutcome.G_GoodFit}`)
        break;
      case "E-S":
        setMappixOutcomeFinal(`${year}${MarkingOutcome.E_Secure}`)
        break;
      case "E-G":
        setMappixOutcomeFinal(`${year}${MarkingOutcome.E_GoodFit}`)
        break;
      case "E-J":
        setMappixOutcomeFinal(`${year}${MarkingOutcome.E_Just}`)
        break;
      case "W-S":
        setMappixOutcomeFinal(`${year}${MarkingOutcome.W_Secure}`)
        break;
      case "W-G":
        setMappixOutcomeFinal(`${year}${MarkingOutcome.W_GoodFit}`)
        break;
      case "W-J":
        setMappixOutcomeFinal(`${year}${MarkingOutcome.W_Just}`)
        break;
      case "B":
        setMappixOutcomeFinal(`${year}${MarkingOutcome.Below}`)
        break;
      default:
        setMappixOutcomeFinal(`${year}${MarkingOutcome.Below}`)
        break
      }
    }
    else {
      errorMsg("Year Not Found")
    }
  }

  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  const openAddEvidenceModal = async () => {
    setSelectEvidences([]);
    const allEvidences = await assessmentAPi.getEvidenceByClassId({ pupilId: assessmentData && assessmentData.assessmentInfo.pupilId });
    const all = [];
    allEvidences.Items.forEach((item) => {
      if (item.evidence && item.evidence.length > 0) {
        item.evidence.forEach((evidence) => {
          all.push({
            id: item.id,
            name: evidence.name,
            date: item.date,
            url: evidence.key,
          });
        });
      }
    });
    all.sort((a, b) => new Date(b.date) - new Date(a.date));
    setAllEvidence(all);
    setDisplayEvidence(evidence);
    setOpenEvidenceModal(true);
  }

  const closeEvidenceModal = async () => {
    setOpenEvidenceModal(false);
  }

  const selectEvidence = (name, date, id, url) => {
    const data = [...displayEvidence]
    const obj = {
      id: id,
      name: name,
      date: date,
      url: url
    }
    data.push(obj);
    data.sort((a, b) => new Date(b.date) - new Date(a.date));
    setDisplayEvidence(data);
    setSelectEvidences(data);
  }
  const unSelectEvidence = (name, date, id, url,) => {
    const unSelectedOne = displayEvidence.filter(d => d.url !== url);
    const unSelectedTwo = evidence?.filter(d => d.url !== url);
    setDisplayEvidence(unSelectedOne);
    setEvidence(unSelectedTwo);
    setSelectEvidences(unSelectedTwo);
  }
  const handleAddEvidence = async () => {
    setOpenEvidenceModal(false);
    const mergedArray = Array.from(new Set([...evidence, ...displayEvidence].map(item => JSON.stringify(item)))).map(item => JSON.parse(item));
    setEvidence(mergedArray);
    setDisplayEvidence(mergedArray);
  }

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const uploadNewEvidence = async () => {
    const filesPaths = files?.map(item => { return item });
    const formData = {
      classId: classId,
      evidences: filesPaths,
      pupilIds: [assessmentData && assessmentData.assessmentInfo.pupilId],
      subsubject: ["Writing"]
    }
    const signedUrls = await commonApi.getSignedUrls(formData);
    if (!isEmptyObject(signedUrls)) {
      let uploadParams = signedUrls.Items;
      if (Array.isArray(uploadParams)) {
        for (let index = 0; index < uploadParams.length; index++) {
          let keyNameArr = Object.keys(uploadParams[index]);
          let keyName = keyNameArr[0];
          let blobField = files[index]
          let tempObj = uploadParams[index];
          await fetch(tempObj[keyName], {
            method: "PUT",
            body: blobField
          });
          const evidenceObj = {
            id: uuidv4(),
            name: blobField.name,
            date: new Date().toLocaleString("en-US", { year: "numeric", month: "short", day: "numeric" }),
            url: tempObj.evidence.split("?")[0],
          }
          const data = [...displayEvidence];
          const evidenceNewObj = data.filter(d => d.name === evidenceObj.name);
          if (isEmptyArray(evidenceNewObj)) {
            data.push(evidenceObj);
            setDisplayEvidence(data);
          }
        }
        !onLoad ? openAddEvidenceModal() : setOnLoad(false);
      }
    }
  }

  const removeEvidence = async (evd) => {
    if (!isSubmited) {
      const allEvidences = evidence?.filter(e => e !== evd);
      setEvidence(allEvidences);
      success(SUCCESS.EVIDENCE_DELETED);
    } else {
      errorMsg(AssessmentDisabledTexts.EvidenceCannotBeDeleted);
    }
  }

  const editEvidenceName = async (evd) => {
    if (!isSubmited) {
      setSelectedEvidence(evd);
      setInputValue(evd.name);
      openModal();
    }
    else {
      errorMsg(AssessmentDisabledTexts.EvidenceCannotBeEdit);
    }
  }

  const openModal = () => {
    setModalIsOpen(true);
  }

  const closeModal = () => {
    setModalIsOpen(false);
  }

  const handleChange = (event) => {
    setInputValue(event.target.value);
  }

  const handleFormSubmit = async (event) => {
    event.preventDefault();
    if (inputValue !== "" && inputValue !== selectedEvidence.name) {
      const renameEvidence = evidence?.map(e => {
        if (e.url === selectedEvidence.url) {
          success("saved successfully")
          return {
            id: e.id,
            name: inputValue,
            date: e.date,
            url: e.url,
          }
        }
        else {
          return e;
        }
      }
      )
      setEvidence(renameEvidence)
    }
    closeModal();
  }


  const saveComment = () => {
    setOpenCommentModal(false)
    setCommentText(tempComment)
  }

  const setOverAllOutCome = (value) => {
    setStudentOutcome(value)
  }

  useEffect(() => {
    if (assessmentData.latestAssessment.length === 0) {
      handleCreateAssessment()
      _teacherOutcome()
    } else {
      setAssessmentId(assessmentData.latestAssessment[0].assessmentId)
      getAssessment(assessmentData.latestAssessment[0].assessmentId)
      _teacherOutcome()
    }
    dispatch(setSelect(NavigationBar.MyClasses))
  }, [])
  useEffect(() => {
    setObjectives(markingData)
  }, [markingData])

  useEffect(() => {
    files && uploadNewEvidence();
  }, [files])

  useEffect(() => {
    let count = 0
    overAllData && overAllData.markings.map((item) => { if (item.markings[0] !== "0") { count++ } })
    if (overAllData !== undefined) {
      if (count === overAllData.markings.length) { setIsAllMarked(false); }
      else { setIsAllMarked(true) }
    }
  }, [isHovered])

  const _teacherOutcome = () => {
    let options = [];
    let suffix = [AssessmentDisabledTexts.GreaterDepth, AssessmentDisabledTexts.Expected, AssessmentDisabledTexts.WorkingTowards, AssessmentDisabledTexts.Below];
    for (let i = year; i > 0; i--) {
      suffix.forEach((item) =>
        options.push({ value: `Year ${i}${item}`, label: `Year ${i}${item}` })
      );
    }
    options.unshift({ value: "", label: "Select" })
    setTeacherOutcomeOptions(options)
  };

  const teachersColour = (outcome) => {
    let bg = AssessmentDisabledTexts.None;
    switch (outcome) {
    case `Year ${year} Greater Depth`: bg = MarkingColors.GreaterDepth
      break;
    case `Year ${year} Expected Standard`: bg = MarkingColors.Expected
      break;
    case `Year ${year} Working Towards`: bg = MarkingColors.Emerging
      break;
    case `Year ${year} Below`: bg = MarkingColors.Below
      break;
    default: bg = MarkingColors.Below
    }
    return bg
  }


  return (
    <div className="Page-layout">
      <div className="Page-header" style={{ paddingBottom: "10px" }}>
        <div className="writing-assessment-page">
          <Row>
            <Col xs={12}>
              <Header />
            </Col>
          </Row>
          <div className="writing-assessment" style={{ marginRight: !isNavCollapsed ? "150px" : "" }}>
            {isLoading && <LoadingSpinner />}
            <Col xs={8}>
              <div className="writing-assessment-info">
                <Row>
                  <Col xs={12}>
                    <AssessmentInfo assessmentData={assessmentData && assessmentData} />
                  </Col>
                </Row>
              </div>
              <div className="assessment-content">
                <Row>
                  <Col xs={12}>
                    <Row>
                      <Col sm={12} md={8}>
                        <Row>
                          <Col sm={12}>
                            <Row className="prior-functions">
                              <Col xs={12} md={6}>
                                {!submittedDisplay && <Button className="prior-marking-btn mb-3" onClick={togglePriorMarking} isDisabled={isSubmited}>{hidepriorMarks ? Marking.ShowPriorMarking : Marking.HidePriorMarking}</Button>}
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={4}>
                      </Col>
                    </Row>
                    <Col sm={12}>
                      <Col xs={12}>
                        <div className="marking-blocks">
                          {priorMarks && objectives && objectives.map((obj, i) => {
                            return (
                              <div key={i}>
                                <ObjectiveBlock assmnt={assmnt && assmnt} obj={obj} index={i} isSubmited={isSubmited} priorMarks={priorMarks && priorMarks[i]} setPriorMarks={setPriorMarks} hidepriorMarks={hidepriorMarks} objectives={objectives} overAllData={overAllData && overAllData} setOverAllData={setOverAllData} setDatas={setDatas} currentYear={year} setTwoDArray={setTwoDArray} twoDArray={twoDArray && twoDArray} submittedDisplay={submittedDisplay} />
                              </div>
                            )
                          })}
                        </div>
                      </Col>
                    </Col>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xs={4}>
              <div className="assessment-functions">
                <Col xs={12} >
                  {!submittedDisplay && <button type="button" className="add-evidence-btn" onClick={openAddEvidenceModal} disabled={isSubmited} >{Marking.AddEvidence} <img src={AddW} alt="" /></button>}
                </Col>
                <Col xs={12}>
                  <div className="assessment-evidence-header">
                    <Col xs={6} className="evidence-header-text">{Marking.Evidence}</Col>
                    <Col xs={6} className="evidence-header-text">{Marking.DateAdded}</Col>
                  </div>
                </Col>
                <Col xs={12} className="assessment-evidences">
                  {evidence && evidence.map((evd, i) => {
                    return (
                      <Col key={i} xs={12} style={{ display: "flex", padding: "5px 20px" }}>
                        <Col xs={6} style={{height : "auto"}}>
                          <span className="evidence-name" style={{ font: "Manrope", color: "#011C25", fontSize: "10px", fontWeight: "600", textDecorationLine: "underline", textOverflow : "clip" }}>{<a href={`${Url.s3BucketUrl}${evd.url}`} target="_blank" rel="noreferrer">{evd?.name.length > 15 ? `${evd?.name?.substring(0,15)}...` : evd?.name}</a>}</span>
                        </Col>
                        <Col xs={4}>
                          <span className="evidence-date" style={{ font: "Manrope", color: "#011C25", fontSize: "10px", fontWeight: "600" }}>{evd.date}</span>
                        </Col>
                        <Col xs={1} className="EvidenceEditIcon" onClick={() => editEvidenceName(evd)}>
                          <img src={EditGrey} alt="" />
                        </Col>
                        <Col xs={1} className="EvidenceRemoveIcon" onClick={() => removeEvidence(evd)}>
                          <img src={Remove} alt="" />
                        </Col>
                      </Col>
                    )
                  })}
                </Col>
                {submittedDisplay ? (<Col xs={12} className="assessment-outcomes">
                  <span className="mappix-outcome-header"> OutCome</span>
                  <span className="mappix-outcome" style={studentOutcome ? { background: teacherOutcomeFinal ? teachersColour(teacherOutcomeFinal) : markingColour(studentOutcome) } : {}}>
                    {(studentOutcome ? ` ${studentOutcome}` : "")}
                  </span>
                </Col>
                ) : (
                  <Col xs={12} className="assessment-outcomes">
                    <span className="mappix-outcome-header">{Marking.MappixCalculatedOutcome}</span>
                    {!submittedDisplay && <Tooltip title={isAllMarked ? AssessmentDisabledTexts.DisabledOutcome : ""} placement="top" style={{ background: "#000", color: "#FFF" }}>
                      <button onClick={calculateOutcome} className="mappix-outcome" style={{ background: "#084059" }} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut} onFocus={handleMouseOver} onBlur={handleMouseOut} disabled={isAllMarked}>
                        Calculate outcome
                      </button>
                    </Tooltip>}
                    {(parseInt(year) === 2 || parseInt(year) === 6) ? (
                      <span className="mappix-outcome" style={mappixOutcomeFinal ? { background: markingColour(mappixOutcomeFinal) } : {}}>
                        {mappixOutcomeFinal ? `${mappixOutcomeFinal} ${Marking.Grade[mappixOutcomeFinal[1]]}` : ""}
                      </span>
                    ) : (
                      !submittedDisplay ? <span className="mappix-outcome" style={mappixOutcomeFinal ? { background: markingColour(mappixOutcomeFinal) } : {}}>
                        {(mappixOutcomeFinal ? ` ${mappixOutcomeFinal}` : "")}
                      </span> : <span className="mappix-outcome" style={{ background: markingColour(mappixOutcomeFinal) }}>
                        {(mappixOutcomeFinal ? ` ${mappixOutcomeFinal}` : "")}
                      </span>
                    )}
                    <span className="teacher-outcome-header">{Marking.TeacherAssessmentOutcome}</span>
                    {!submittedDisplay && (teacherOutcomeFinal || teacherOutcomeFinal === "") && <Select className="teacher-outcome" defaultValue={teacherOutcomeFinal && teacherOutcomeFinal ? { value: teacherOutcomeFinal, label: teacherOutcomeFinal } : null} placeholder="Select" options={teacherOutComeOptions && teacherOutComeOptions} isDisabled={isSubmited} onChange={(e) => { getTeacherOutcome(e); }}></Select>}
                  </Col>
                )}
                <Col xs={12} className="assessment-comment-box">
                  {!submittedDisplay ? <button className="add-comment" onClick={openCommentBox} disabled={isSubmited}><img src={Chat} alt="" /> {Common.AddComment}</button> : <span>{Common.Comment}</span>}
                  <p className="comment-box" style={{ overflowWrap: "anywhere" }}>{commentText}</p>
                </Col>
                {
                  !submittedDisplay && <Col xs={12} className="assessment-function-butotns">
                    <div className="d-flex flex-row">
                      <Col xs={5}>
                        <Tooltip title={(isSubmited || !mappixOutcomeFinal) ? "Please Calculate Outcome Before Saving" : ""}>
                          <button onClick={handleAssessmentSave} type="button" className="save-btn" disabled={(isSubmited || !mappixOutcomeFinal)}>{Common.Save} </button>
                        </Tooltip>
                      </Col>
                      <Col>
                        {asstSaved && <button onClick={handleSubmit} type="button" className="submit-btn" disabled={isSubmited}> {Common.Submit} </button>}
                      </Col>
                    </div>
                    <Row className="d-flex justify-content-end" style={{ marginTop: "20px" }}>
                      <Col style={{ marginRight: "0px" }} className="d-flex justify-content-end">
                        {asstSaved && <button type="button" onClick={handleAssessmentDelete} className="delete-btn" disabled={isSubmited} style={{ width: "117px" }}> {Common.Delete}</button>}
                      </Col>
                    </Row>
                  </Col>}
              </div>
            </Col>
          </div>
          <Modal show={openEvidenceModal} onHide={closeEvidenceModal} className="comment-modal">
            <Modal.Header className="addEvidenceHeader">
              <Col>Evidence</Col>
              <Col>Date Added</Col>
              <Col>Select</Col>
            </Modal.Header>
            <Modal.Body className="addEvidenceModalBody">
              <Row>
                {
                  allEvidence.length > 0 ? allEvidence.map((a, i) => (
                    <div className="d-flex align-items-center" key={i}>
                      <span className="EvidenceNameFirst">{a.name}</span>
                      <span className="EvidenceDateFirst">{a.date}</span>
                      <span>{displayEvidence && isEmptyArray(displayEvidence.filter(d => d.url === a.url)) ? <button className="EvidenceSelectRoundButton RedButton" onClick={() => selectEvidence(a.name, a.date, a.id, a.url)}><img src={RoundButtonRedColor} alt="" /></button> : <button className="EvidenceSelectRoundButton BlackButton" onClick={() => unSelectEvidence(a.name, a.date, a.id, a.url,)}><img src={RoundButtonCheked} alt="" /></button>}</span>
                    </div>
                  )) :
                    <div><h3>{AssessmentDisabledTexts.NoEvidenceFound}</h3></div>
                }
              </Row>
            </Modal.Body>
            <Modal.Footer className="comment-modal-footer">
              <div {...getRootProps()}>
                <input {...getInputProps()} />
                <button className="addEvidenceUploadNew" >{AssessmentDisabledTexts.UploadNew} <img src={ClassHomeUploadIcon} alt="ClassHomeUploadIcon" /></button>
              </div>
              {!displayEvidence.length > 0 || !selectEvidences.length > 0 ? <button className="addEvidenceButtonOne" type="button" onClick={handleAddEvidence} disabled>
                <div className="d-flex justify-content-between">
                  <span className="addEvidenceButtonContentOne">{AssessmentDisabledTexts.AddEvidence}<span className="addEvidenceUploadIcon"><img src={AttachFileBlue} alt="" /></span></span>
                </div>
              </button> : <button className="addEvidenceButton" type="button" onClick={handleAddEvidence} >
                <div className="d-flex justify-content-between">
                  <span className="addEvidenceButtonContent">{AssessmentDisabledTexts.AddEvidence}<span className="addEvidenceUploadIcon"><img src={AttachFile} alt="" /></span></span>
                </div>
              </button>}
              <button className="upload-cancel" type="button" onClick={closeEvidenceModal}>Cancel</button>
            </Modal.Footer>
          </Modal>
          <Modal show={modalIsOpen} onHide={closeModal} className="comment-modal">
            <Modal.Body className="editNameModalBody">
              <form onSubmit={handleFormSubmit}>
                <label className="editNameLabel">
                  {AssessmentDisabledTexts.EnterNewName}
                  <input type="text" className="editNameInputTag" value={inputValue} onChange={handleChange} />
                </label>
                <button type="submit" className="editNameSubmitButton">{Common.Submit}</button>
                <button onClick={closeModal} type="button" className="editNameCloseButton">{Common.Close}</button>
              </form></Modal.Body>
          </Modal>
          <Modal show={openCommentModal} onHide={handleClose} className="comment-modal">
            <Modal.Header className="comment-modal-header">
              {Common.AddComment}<img src={Chat} alt="" />
            </Modal.Header>
            <Modal.Body className="comment-modal-body">
              <div className="comment-modal-box">
                <textarea id="assessment-comment" name="assessment-comment" className="assessment-comment" rows="4" cols="65" onChange={(e) => { setTempComment(e.target.value) }} defaultValue={commentText}></textarea>
              </div>
            </Modal.Body>
            <Modal.Footer className="comment-modal-footer">
              <button className="comment-modal-cancelbtn cancelButton" onClick={handleClose} >Cancel</button>
              <button name="addComment" className="comment-modal-savebtn saveButton" onClick={() => { saveComment() }}><img src={SaveBtn} alt="" /> {Common.SaveComment}</button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  )
}

const ObjectiveBlock = (props) => {
  const { assmnt, obj, index, isSubmited, priorMarks, hidepriorMarks, setPriorMarks, objectives, overAllData, setOverAllData, setDatas, currentYear, twoDArray, submittedDisplay } = props;
  let priorbackgroundColour = "#E0E0E0"
  const whitetextColour = "#FFFFFF";
  const boxborder = "";
  const [marked, setMarked] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const handleClose = () => setOpenModal(false);

  const openSelector = async () => {
    setOpenModal(true)
  }

  const stlyes = {
    belowObjBox: {
      background: MarkingColors.Below,
    },
    emergingObjBox: {
      background: MarkingColors.Emerging,
    },
    expectedObjBox: {
      background: MarkingColors.Expected,
    },
    greaterObjBox: {
      background: MarkingColors.GreaterDepth,
    },
    defaultObjBox: {
      background: "#E0E0E0",
    }
  }

  if (priorMarks) {
    if (priorMarks.markings[0][0] !== "B") {
      switch (priorMarks.markings[0][1]) {
      case MarkingLevels.GrD:
        priorbackgroundColour = stlyes.greaterObjBox.background;
        break;
      case MarkingLevels.Exp:
        priorbackgroundColour = stlyes.expectedObjBox.background;
        break;
      case MarkingLevels.Eme:
        priorbackgroundColour = stlyes.emergingObjBox.background;
        break;
      case MarkingLevels.Bel:
        priorbackgroundColour = stlyes.belowObjBox.background;
        break;
      default:
        priorbackgroundColour = stlyes.defaultObjBox.background;
      }
    }
    else if (priorMarks.markings[0][0] === "B") {
      priorbackgroundColour = stlyes.belowObjBox.background;
    }
  }

  useEffect(() => {
    if (overAllData.markings[index].markings[0] !== "0") {
      setMarked(true);
    }
  }, [overAllData.markings[index].markings[0], marked])

  return (
    <div className="objective-block">
      {overAllData.markings[index].markings.length === 1 ? <Button className="objective-button" onClick={openSelector} style={{ background: overAllData.markings[index].color ? overAllData.markings[index].color : "#E0E0E0", border: boxborder }} disabled={isSubmited}>
        <span className="objective-block-name" style={{ color: marked ? "white" : "black" }}>{overAllData.markings[index].name}</span>
        {marked && <span className="objective-block-name" style={{ color: "white" }}>{overAllData.markings[index].markings[0] && overAllData.markings[index].markings[0]}</span>}
      </Button> :
        <Button className="objective-button" onClick={openSelector} style={{ background: overAllData.markings[index].color ? overAllData.markings[index].color : "#E0E0E0", border: boxborder }} disabled={isSubmited}>
          <span className="objective-block-name" style={{ color: marked ? "white" : "black" }}>{overAllData.markings[index].name}</span>
          {marked && <span className="objective-block-name" style={{ color: "white" }}>{overAllData.markings[index].markings[1] && overAllData.markings[index].markings[1]}</span>}
        </Button>}
      {submittedDisplay ? "" : hidepriorMarks ? "" : (priorMarks.markings[0] !== "0" ?
        <span className="prior-marking-view" style={{ color: whitetextColour, background: priorMarks.color ? priorMarks.color : priorbackgroundColour }}>{priorMarks.markings.length === 1 ? priorMarks.markings[0] : priorMarks.markings[1]}</span> :
        <span className="prior-marking-view" style={{ background: priorbackgroundColour }}><img src={WhitePriorMarking} alt="" /></span>)}
      <Modal show={openModal} className="objective-mark-selector" onHide={handleClose} aria-labelledby="contained-modal-title-vcenter" centered>
        <Modal.Header>
          {obj.name && obj.name}
        </Modal.Header>
        <Modal.Body>
          <ObjectiveLevelSelector assmnt={assmnt} category={obj.category} description={obj.name} identifier={obj.generalIdentifier} setPriorMarks={setPriorMarks} priorMarks={priorMarks} index={index} handleClose={handleClose} obj={obj} objectives={objectives} overAllData={overAllData} setOverAllData={setOverAllData} setDatas={setDatas} currentYear={currentYear} twoDArray={twoDArray && twoDArray} />
        </Modal.Body>
      </Modal>
    </div>
  )
}

const ObjectiveLevelSelector = (props) => {
  const { category, identifier, index, description, handleClose, overAllData, setDatas, currentYear, twoDArray } = props;
  const dispatch = useDispatch();
  const [criteria, setCriteria] = useState([]);
  const [_scroll, _setScroll] = useState(false)
  let marks = overAllData.markings;

  const fetchDescriptionCriteria = async () => {
    const _criteria = await assessmentAPi.fetchDescriptionCriteria({ "year": currentYear, identifier });
    if (!isEmptyObject(_criteria)) {
      if (!isEmptyArray(_criteria.Items)) {
        setCriteria(_criteria.Items.sort((a, b) => b.year - a.year));
      }
    }
  }

  const getValue = (year, value, key, start, color, data) => {
    let markValue = `${year}${value}`
    for (let i = 0; i < marks.length; i++) {
      if (marks[i].category === category) {
        if (marks[i].name === description) {
          dispatch(setMark({ i: i, value: markValue }))
          for (let j = 0; j < twoDArray?.length; j++) {
            if (j === start) {
              twoDArray[j][i] = 1;
            }
            else {
              twoDArray[j][i] = 0;
            }
          }
          const updatedOverAllData = {
            ...overAllData,
            markings: overAllData.markings.map((item, i) => {
              if (i === index) {
                return {
                  ...item,
                  markings: year !== currentYear ? [`${currentYear}B`, `${year}${value}`] : [`${year}${value}`],
                  color: funColor(color, data)
                };
              }
              return item;
            }),
          };
          setDatas(updatedOverAllData);
        }
      }
    }
    handleClose();
  }

  const handleScroll = () => {
    _setScroll(true)
  }

  useEffect(() => {
    fetchDescriptionCriteria();
  }, [])

  let id = 0;
  const funColor = (level, data) => {
    for (const element of data) {
      const markLevel = element.markLevels.find(mark => mark.level === level);
      if (markLevel) {
        return markLevel.color;
      }
      else {
        return "var(--below-colour)"
      }
    }
  }
  if (_scroll) {
    return (
      <div className="fit-scroll">
        {overAllData && <div className="objective-level-selector">
          {criteria && criteria.map((description, i) => {
            let keyArr = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11], [12, 13, 14], [15, 16, 17]];
            const start = 3 * i;
            return (
              <div key={i}>
                <div className="dropdown-option" key={id++} onClick={() => { getValue(description.year, MarkingLevels.GrD, `${keyArr[i][0]}`, start + 0, `${criteria[i].year}G`, criteria) }} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") getValue(description.year, MarkingLevels.GrD, `${keyArr[i][0]}`, start + 0, `${criteria[i].year}G`, criteria); }} tabIndex={0} role="button"
                >
                  <span className="heading"
                    style={{ background: funColor(`${criteria[i].year}G`, criteria) }} >YEAR {description.year && description.year} {MarkingLevels.GreaterDepth}</span>
                  <p className="description">{description.greaterDepth && description.greaterDepth}</p>
                </div>
                <div className="dropdown-option" onClick={() => { getValue(description.year, MarkingLevels.Exp, `${keyArr[i][1]}`, start + 1, `${criteria[i].year}E`, criteria) }} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") getValue(description.year, MarkingLevels.Exp, `${keyArr[i][1]}`, start + 1, `${criteria[i].year}E`, criteria); }} tabIndex={0} role="button">
                  <span className="heading" style={{ background: funColor(`${criteria[i].year}E`, criteria) }} >YEAR {description.year && description.year} {MarkingLevels.Expected}</span>
                  <p className="description">{description.expected && description.expected}</p>
                </div>
                <div className="dropdown-option" onClick={() => { getValue(description.year, MarkingLevels.Eme, `${keyArr[i][2]}`, start + 2, `${criteria[i].year}W`, criteria) }} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") getValue(description.year, MarkingLevels.Eme, `${keyArr[i][2]}`, start + 2, `${criteria[i].year}W`, criteria); }} tabIndex={0} role="button">
                  <span className="heading" style={{ background: funColor(`${criteria[i].year}W`, criteria) }} >YEAR {description.year && description.year} {MarkingLevels.WorkingTowards}</span>
                  <p className="description">{description.emerging && description.emerging}</p>
                </div>
              </div>
            )
          })}
          {criteria && <div className="dropdown-option" onClick={() => { getValue(criteria[criteria.length - 1]?.year, MarkingLevels.Bel, "", criteria.length * 3, `${criteria[criteria.length - 1].year}B`, criteria) }} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") getValue(criteria[criteria.length - 1]?.year, MarkingLevels.Bel, "", criteria.length * 3, `${criteria[criteria.length - 1].year}B`, criteria); }} tabIndex={0} role="button">
            <span className="heading" style={{ background: MarkingColors.Below }} >BELOW</span>
            <p className="description">{AssessmentDisabledTexts.Below.toUpperCase()}</p>
          </div>}
        </div>
        }
      </div>
    )
  }
  else {
    return (
      <div className="fit-scroll">
        {overAllData && (
          <div className="objective-level-selector">
            {criteria &&
              criteria.map((description, i) => {
                let keyArr = [[0, 1, 2], [3, 4, 5], [6, 7, 8], [9, 10, 11], [12, 13, 14], [15, 16, 17]];
                const start = 3 * i;
                return i === 0 ? (
                  <div key={i}>
                    <div className="dropdown-option" key={id++} onClick={() => { getValue(description.year, MarkingLevels.GrD, `${keyArr[i][0]}`, start + 0, `${criteria[i].year}G`, criteria) }} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") getValue(description.year, MarkingLevels.GrD, `${keyArr[i][0]}`, start + 0, `${criteria[i].year}G`, criteria); }} tabIndex={0} role="button">
                      <span
                        className="heading"
                        style={{ background: funColor(`${criteria[i].year}G`, criteria) }}
                      >
                        YEAR {description.year && description.year} {MarkingLevels.GreaterDepth}
                      </span>
                      <p className="description">{description.greaterDepth && description.greaterDepth}</p>
                    </div>
                    <div className="dropdown-option" onClick={() => {
                      getValue(description.year, MarkingLevels.Exp, `${keyArr[i][1]}`, start + 1, `${criteria[i].year}E`, criteria);
                    }} tabIndex={0} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") getValue(description.year, MarkingLevels.Exp, `${keyArr[i][1]}`, start + 1, `${criteria[i].year}E`, criteria); }} role="button">
                      <span
                        className="heading"
                        style={{ background: funColor(`${criteria[i].year}E`, criteria) }}
                      >
                        YEAR {description.year && description.year} {MarkingLevels.Expected}
                      </span>
                      <p className="description">{description.expected && description.expected}</p>
                    </div>
                    <div className="dropdown-option" onClick={() => {
                      getValue(description.year, MarkingLevels.Eme, `${keyArr[i][2]}`, start + 2, `${criteria[i].year}W`, criteria);
                    }} tabIndex={0} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") getValue(description.year, MarkingLevels.Eme, `${keyArr[i][2]}`, start + 2, `${criteria[i].year}W`, criteria); }} role="button">
                      <span
                        className="heading"
                        style={{ background: funColor(`${criteria[i].year}W`, criteria) }}
                      >
                        YEAR {description.year && description.year} {MarkingLevels.WorkingTowards}
                      </span>
                      <p className="description">{description.emerging && description.emerging}</p>
                    </div>
                    <div className="dropdown-option d-flex flex-row" style={{ minHeight: 0, background: MarkingColors.Below }}>
                      <div
                        className="heading"
                        style={{ background: MarkingColors.Below, width: "85%" }}
                        onClick={() => {
                          getValue(criteria[criteria.length - 1]?.year, MarkingLevels.Bel, "", criteria.length * 3, `${criteria[criteria.length - 1].year}B`, criteria);
                        }} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") getValue(criteria[criteria.length - 1]?.year, MarkingLevels.Bel, "", criteria.length * 3, `${criteria[criteria.length - 1].year}B`, criteria); }} role="button" tabIndex={0}
                      >
                        {AssessmentDisabledTexts.Below}
                      </div>
                      <span className="d-flex align-items-center" style={{ color: "#FFF" }} onClick={handleScroll} onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") getValue(criteria[criteria.length - 1]?.year, MarkingLevels.Bel, "", criteria.length * 3, `${criteria[criteria.length - 1].year}B`, criteria); }} tabIndex={0} role="button">{AssessmentDisabledTexts.Scroll}</span>
                    </div>
                  </div>
                ) : null;
              })}
          </div>
        )}
      </div>
    )
  }
}

export { AssessmentMarking }